/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import { amber, green, red, blue } from '@mui/material/colors';
import { Snackbar, SnackbarContent, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { SnakbarNotificationProps } from './SnakbarNotification.types';

const SnakbarNotification = (props: SnakbarNotificationProps) => {
    const {
        message,
        variant,
        show,
        handleClose,
        sx,
        autoHideDuration,
        autoHide,
    } = props;

    const getBackgroundColour = () => {
        switch (variant) {
            case 'error':
                return red[900];
            case 'success':
                return green[600];
            case 'warning':
                return amber[700];
            default:
                return blue[800];
        }
    };

    const getTextColour = () => {
        return variant === 'warning' ? '#000' : '#FFF';
    };

    return (
        <Snackbar
            sx={{
                backgroundColor: getBackgroundColour(),
                color: getTextColour(),
                ...sx,
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={show}
            autoHideDuration={autoHide ? autoHideDuration : null}
            onClose={handleClose}
        >
            <SnackbarContent
                sx={{
                    backgroundColor: getBackgroundColour(),
                    color: getTextColour(),
                    display: 'flex',
                    '& .MuiSnackbarContent-message': {
                        flex: '1',
                    },
                    '& .MuiSnackbarContent-action': {
                        flex: 'none',
                    },
                }}
                aria-describedby="message-id"
                message={<span id="message-id">{message}</span>}
                action={[
                    <IconButton
                        key="close"
                        aria-label="close"
                        color="inherit"
                        sx={{ padding: 0.5 }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>,
                ]}
            />
        </Snackbar>
    );
};

SnakbarNotification.propTypes = {
    message: PropTypes.string,
    show: PropTypes.bool.isRequired,
    variant: PropTypes.oneOf(['error', 'info', 'success', 'warning'])
        .isRequired,
    sx: PropTypes.object,
    handleClose: PropTypes.func.isRequired,
    autoHideDuration: PropTypes.number,
    autoHide: PropTypes.bool.isRequired,
};

SnakbarNotification.defaultProps = {
    sx: {},
};

export default SnakbarNotification;
